// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OGaG","colBig":"styles_colBig__JcnBx","colSmall":"styles_colSmall__mMAhN","shopifyNameWrapper":"styles_shopifyNameWrapper__1nWeU"};